import React, {useState} from 'react'
import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffectOnce} from "../../hooks/useEffectOnce";

import styles from "./PaymentResult.module.css"

import * as UserService from "../../api/UserService"
import {useTranslation} from "react-i18next";

export default function PaymentResult() {
    const [status, setStatus] = useState()
    const { t,i18n } = useTranslation('translation', { keyPrefix: 'paymentResult' });

    const [queryParams] = useSearchParams()

    const nav = useNavigate()

    useEffectOnce(() => {
        UserService.getPaymentResult(queryParams.get("session_id"),
            (response) => {
                setStatus(response.stastus)
            },
            () => {
            }
        )
    })

    return <div className={styles.page}>
        <div className={styles.container}>
            {queryParams.get("result") === "success" && <div>
                <span className={styles.loader}></span>
            </div>
            }
            {queryParams.get("result") === "success" && status === "complete" && <div>
                <div className={styles.successSign}/>
                <div className={styles.textItem}>{t('paymentSuccessful')}</div>
                <div className={styles.textItem}>{t('goodGameWish')}</div>


            </div>
            }

            {queryParams.get("result") === "cancel" && <div>
                <div className={styles.cancelSign}/>
                <div className={styles.textItem}>{t('paymentDeclined')}</div>

            </div>}

            <div className={styles.returnButton} onClick={() => nav('/mentor/cabinet')}>{t('backToMentorCabinet')}</div>
        </div>
    </div>
}